import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
    },
    {
        path: 'home',
        loadComponent: () => import('./page/root-page/root-page').then(m => m.RootPage)
    },
    {
        path: 'build',
        loadComponent: () => import('./page/root-page/root-page').then(m => m.RootPage)
    },
    {
        path: 'build/:builderId',
        loadComponent: () => import('./page/root-page/root-page').then(m => m.RootPage)
    },
    {
        path: 'activity',
        loadComponent: () => import('./page/root-page/root-page').then(m => m.RootPage)
    },
    {
        path: 'activity/:documentId',
        loadComponent: () => import('./page/root-page/root-page').then(m => m.RootPage)
    },
    {
        path: 'sign/:userToken',
        loadComponent: () => import('./features/end-user/end-user/end-user').then(m => m.EndUser)
    }
];
